import { confirmScheduleEventsBatch } from "../../../../../../../../../../api/kehrblatt/schedule-events"
import type { ConfirmAppointmentsOperations } from "../actions/confirmAppointments"

export const confirmAppointmentsOperations: ConfirmAppointmentsOperations = {
  confirm: confirmScheduleEventsBatch,
}
